import { useCallback, useEffect, useState } from "react";
import { Eye, X, Search } from "lucide-react";
import api from "@/lib/api";
import { COPPER } from "./VestaAuth";

const KEY = "vesta_as";
export const getAs = () => { try { return JSON.parse(sessionStorage.getItem(KEY) || "null"); } catch { return null; } };
const setAs = (v) => { v ? sessionStorage.setItem(KEY, JSON.stringify(v)) : sessionStorage.removeItem(KEY); window.dispatchEvent(new Event(KEY)); };
// Id del Partner in vista (o "" in Vista rete): cambia quando si sceglie/esce da «Vedi come Partner»
export function useAsId() {
  const [id, setId] = useState(() => getAs()?.id || "");
  useEffect(() => { const f = () => setId(getAs()?.id || ""); window.addEventListener(KEY, f); return () => window.removeEventListener(KEY, f); }, []);
  return id;
}

// Dati /vesta/me, rispettando la "vista come Partner" di admin / Head of Partner
export function useVestaMe() {
  const [me, setMe] = useState(null);
  const load = useCallback(() => {
    const as = getAs();
    api.get("/vesta/me", { params: as ? { as: as.id } : {} }).then((r) => setMe(r.data))
      .catch((e) => { if (as && [400, 403, 404].includes(e.response?.status)) setAs(null); });
  }, []);
  useEffect(() => { load(); window.addEventListener(KEY, load); return () => window.removeEventListener(KEY, load); }, [load]);
  return me;
}

export function ViewAsBar({ me }) {
  const [open, setOpen] = useState(false);
  const [q, setQ] = useState("");
  const [rows, setRows] = useState([]);
  useEffect(() => {
    if (!open) return;
    const t = setTimeout(() => api.get("/vesta/partners", { params: { q } }).then((r) => setRows(r.data.partners || [])).catch(() => setRows([])), 250);
    return () => clearTimeout(t);
  }, [q, open]);
  if (!me || !(me.admin || me.viewing_as)) return null;
  const as = getAs();
  return (
    <div className="border-b border-neutral-900 bg-neutral-950 px-4 py-2 text-xs sm:px-10 sm:text-sm" data-testid="vesta-viewas-bar">
      <div className="flex items-center gap-2 sm:gap-3">
        <Eye className="h-4 w-4 shrink-0" style={{ color: COPPER }} />
        {as ? (
          <>
            <span className="min-w-0 truncate text-neutral-300"><span className="hidden sm:inline">Stai vedendo Ai VESTA come </span><b className="text-white" data-testid="vesta-viewas-name">{as.name}</b></span>
            <button type="button" onClick={() => setAs(null)} className="ml-auto inline-flex shrink-0 items-center gap-1 rounded-full border border-neutral-700 px-2.5 py-1 text-xs text-neutral-300 hover:border-[#C17F59] hover:text-[#C17F59]" data-testid="vesta-viewas-exit" title="Esci dalla vista"><X className="h-3.5 w-3.5" /><span className="hidden sm:inline">Esci dalla vista</span></button>
          </>
        ) : <span className="text-neutral-400" data-testid="vesta-network-label">{me.network ? <><b className="text-white">Vista rete</b><span className="hidden sm:inline"> · tutti i Partner · sola lettura</span></> : "Vista staff"}</span>}
        <button type="button" onClick={() => setOpen(!open)} className={`${as ? "" : "ml-auto"} shrink-0 rounded-full px-3 py-1 text-xs font-bold text-black`} style={{ background: COPPER }} data-testid="vesta-viewas-open">
          {as ? <>Cambia<span className="hidden sm:inline"> Partner</span></> : "Vedi come Partner"}
        </button>
      </div>
      {open && (
        <div className="mt-3 max-w-md rounded-xl border border-neutral-800 bg-black p-3" data-testid="vesta-viewas-panel">
          <div className="mb-2 flex items-center gap-2 rounded-md border border-neutral-800 px-2">
            <Search className="h-4 w-4 text-neutral-500" />
            <input autoFocus value={q} onChange={(e) => setQ(e.target.value)} placeholder="Cerca Partner…" className="h-9 w-full bg-transparent text-sm text-white outline-none" data-testid="vesta-viewas-search" />
          </div>
          <div className="max-h-64 space-y-1 overflow-auto">
            {rows.map((p) => (
              <button key={p.id} type="button" onClick={() => { setAs({ id: p.id, name: p.name }); setOpen(false); setQ(""); }}
                className="flex w-full items-center justify-between rounded-md px-2 py-1.5 text-left text-sm text-neutral-200 hover:bg-neutral-900" data-testid={`vesta-viewas-opt-${p.id}`}>
                <span className={`truncate ${p.direzione ? "font-semibold text-sky-300" : ""}`}>{p.name}</span><span className="ml-2 shrink-0 text-xs text-neutral-500">{p.city || p.province || ""}</span>
              </button>
            ))}
            {rows.length === 0 && <p className="px-2 py-1.5 text-xs text-neutral-500">Nessun Partner trovato</p>}
          </div>
        </div>
      )}
    </div>
  );
}
